/*
 * サブシステム名：マスタ管理
 * 機能名：営業所マスタ一覧
 */
import DdCustomButton from '@/components/DdCustomButton'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')

const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDataTable = () => import('@/components/DdDataTable')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstEigyoshoList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      eigyoshoCd: '',
      eigyoshoKbn: '00',
      eigyoshoNm: '',
      eigyoshoNmKana: '',
      HacchusakiCd: ''
    },
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdDataTable,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)

        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoKbn () {
      console.log('●filteredEigyoshoKbn')
      const listData = this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN002'
      }).map(function (elem) {
        return elem
      })
      return listData
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstEigyoshoList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '営業所コード', value: 'eigyoshoCd' },
              { text: '営業所区分', value: 'eigyoshoKbnNm' },
              { text: '営業所名称', value: 'eigyoshoNm' },
              { text: '営業所正式名称', value: 'eigyoshoSeishikiNm' },
              { text: '営業所名称カナ', value: 'eigyoshoNmKana' },
              { text: '発注先名称', value: 'hacchusakiNm' },
              { text: '郵便番号', value: 'yubinNo' },
              { text: '住所１', value: 'jusho1' },
              { text: '住所２', value: 'jusho2' },
              { text: '住所３', value: 'jusho3' },
              { text: '電話番号', value: 'telNo' },
              { text: 'FAX番号', value: 'faxNo' },
              { text: '地域種別', value: 'chiikiNm' },
              { text: '地区種別', value: 'chikuNm' },
              { text: '運輸局区分', value: 'unyukyoku' },
              // { text: '請求書会社名称', value: 'seikyushoKaishaNm' },
              // { text: '請求書郵便番号', value: 'seikyushoYubinNo' },
              // { text: '請求書住所１', value: 'seikyushoJusho1' },
              // { text: '請求書住所２', value: 'seikyushoJusho2' },
              // { text: '請求書住所３', value: 'seikyushoJusho3' },
              // { text: '請求書電話番号', value: 'seikyushoTelNo' },
              // { text: '請求書FAX番号', value: 'seikyushoFaxNo' },
              // { text: '請求書金融機関名１', value: 'seikyushoKinyukikanNm1' },
              // { text: '請求書支店名１', value: 'seikyushoSitenNm1' },
              // { text: '請求書口座種別１', value: 'seikyushoKozasyubetu1' },
              // { text: '請求書口座番号１', value: 'seikyushoKozaNo1' },
              // { text: '請求書口座名義１', value: 'seikyushoKozaMeigi1' },
              // { text: '請求書金融機関名２', value: 'seikyushoKinyukikanNm2' },
              // { text: '請求書支店名２', value: 'seikyushoSitenNm2' },
              // { text: '請求書口座種別２', value: 'seikyushoKozasyubetu2' },
              // { text: '請求書口座番号２', value: 'seikyushoKozaNo2' },
              // { text: '請求書口座名義２', value: 'seikyushoKozaMeigi2' },
              // { text: '請求書金融機関名３', value: 'seikyushoKinyukikanNm3' },
              // { text: '請求書支店名３', value: 'seikyushoSitenNm3' },
              // { text: '請求書口座種別３', value: 'seikyushoKozasyubetu3' },
              // { text: '請求書口座番号３', value: 'seikyushoKozaNo3' },
              // { text: '請求書口座名義３', value: 'seikyushoKozaMeigi3' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              eigyoshoCd: '',
              eigyoshoKbn: '00',
              eigyoshoNm: '',
              eigyoshoNmKana: '',
              HacchusakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstEigyoshoList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstEigyoshoList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstEigyoshoList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstEigyoshoList.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstEigyosho/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            eigyoshoKbn: self.conditions.eigyoshoKbn
          }
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      this.Effects.loadStart()
      this.search().then(() => {
        console.log('this.search()', this.rows)
        this.Effects.loadComplete()
      })
    },
    search: function () {
      console.log('★', this.conditions.eigyoshoKbn)
      return new Promise(resolve => {
        this.HttpClient
          .post('/api/v1/vwCMstEigyosho/search', this.conditions)
          .then((data) => {
            this.rows = data.payload

            const cache = {
              rows: this.rows,
              conditions: this.conditions,
              searchText: this.searchText
            }
            this.saveToChache(cache)
              .then(() => {
                resolve()
              })
          })
      })
    },
    */
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              eigyoshoCd: '',
              eigyoshoKbn: '00',
              eigyoshoNm: '',
              eigyoshoNmKana: '',
              HacchusakiCd: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCMstEigyosho/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '営業所マスタ一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
